
import "/root/workspace/__flow_work/__flow_builds/4ed6d599-55a5-4f85-8534-0c858affe5ce/workspace/saas-admin/src/styles/layout.module.less?modules";
export default {"menuBadgeWrap": `menuBadgeWrap-jaPHO0B-`,"menuBadge": `menuBadge-8Pm-hyJ_`,"searchUser": `searchUser-PNIGERKK`,"quickOpenCardEntry": `quickOpenCardEntry-TsZw6wM9`,"merchantName": `merchantName-ZPPQ_oo_`}
